import { ar, de, enAU, enCA, enGB, enUS, es, fr, hi, it, id, ja, ko, ms, pt, ptBR, ru, th, tr, vi, zhCN, zhTW, zhHK } from "date-fns/locale";


const localeMap: {[key: string]: Locale} = {
    ar, de, 'en': enUS, 'en-au': enAU, 'en-ca': enCA, 'en-gb': enGB, 'en-us': enUS, es, fr, hi, it, id, ja, pt, 'pt-br': ptBR, ms, ko, ru, th, tr, vi, 'zh': zhCN, 'zh-cn': zhCN, 'zh-hk': zhHK, 'zh-tw': zhTW
}

export const getDateFnsLocale= () => {
    for(let l of navigator.languages) {
        const ll = l.toLowerCase()
        const c = localeMap[ll] || localeMap[ll.slice(0, 2)]
        if (c) return c;
    }
    return undefined
}

export const DATE_FORMAT = 'yyyy-MM-dd';
